import { render, staticRenderFns } from "./FediverseSection.vue?vue&type=template&id=78433a38&"
import script from "./FediverseSection.vue?vue&type=script&lang=js&"
export * from "./FediverseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports